const $window = $(window);
const breakPoint = 767;

let resizeFlag = false;
let windowWidth = $window.width();
let windowHeight = $window.height();
//const bodyLimitHeight = (windowHeight - 185) * 0.88;

let url = location.href;

//ローディング
const loading = () => {
  const $target = $('#sw-Loading');
  window.addEventListener('load',function(){
    setTimeout( () => {
      $target.fadeOut(600);
    }, 1000);
  });
};

//ページ内リンクのアニメーション
const anchorScroll = () => {
  const $anchor = $('a[href^=#]');
  $anchor.click(function () {
    const speed = 1000;
    const href = $(this).attr('href');
    const target = $(href == '#' || href == '' ? 'html' : href);
    const position = target.offset().top;
    $('html, body').animate({
      scrollTop: position
    }, speed, 'swing');
    return false;
  });
};

//ページTOP
const pageTop = () =>{
  const topBtn = $('.sw-BackToTop');
  topBtn.css({visibility:'hidden',opacity: 0});
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      topBtn.css({visibility:'visible',opacity: 1});
    } else {
      topBtn.css({visibility:'hidden',opacity: 0});
    }
  });
  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 1000);
    return false;
  });
};

//SPヘッダーの開閉
const spHeaderToggle = () => {
  //config
  const $header = $('#st-Header');
  //toggle
  const $headerTrigger = $('#st-Header_Hamburger');
  $headerTrigger.on('click', function(){
    $header.toggleClass('opened');
    return false;
  });
};

// Headerスクロール時
const scrolledHeader = () =>{
  const $header = $('.st-Header');
  $(window).scroll(function () {
    if ($(this).scrollTop() > 0) {
      $header.addClass('scrolled');
    } else {
      $header.removeClass('scrolled');
    }
  });
};


// preload
const preload = () =>{
  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });
};

// resizing
const resizing = () =>{
  var timer = 0;
  $(window).on('resize' , function() {
    $("body").addClass("resizing");
    if (timer > 0) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $("body").removeClass("resizing");
      // console.log('window resized');
    }, 100);
  });
};

//export
export {loading, anchorScroll, pageTop, spHeaderToggle, scrolledHeader, preload, resizing};


// WEBPACK FOOTER //
// ./src/assets/js/include/module.js